import { useEffect } from 'react';
import { useUploadStore } from '../../stores/upload';
import { useQueueStatusStore } from '../../stores/queue';

export function StatusBar() {
  const { upload, clearAssetsQueued } = useUploadStore();
  useQueueStatusStore.live();
  const status = useQueueStatusStore(s => s.counts);

  const processingCount = status?.processing ?? 0;
  const awaitingReviewCount = status?.awaiting_review ?? 0;
  const failedCount = status?.failed ?? 0;
  const showHashing = upload.hashing !== null;
  const showUpload = upload.active && !showHashing;
  const showProcessing = processingCount > 0;

  useEffect(() => {
    if (processingCount === 0 && !upload.active && upload.assetsQueued > 0) {
      const timer = setTimeout(() => {
        clearAssetsQueued();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [processingCount, upload.active, upload.assetsQueued, clearAssetsQueued]);

  if (!showHashing && !showUpload && !showProcessing) {
    return null;
  }

  return (
    <div className="border-t bg-background px-4 py-1 text-xs font-mono text-muted-foreground flex items-center gap-4">
      {showHashing && upload.hashing && (
        <>
          <span>
            Checking {upload.hashing.completed}/{upload.hashing.total}
          </span>
          <div className="w-32 h-1.5 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-300"
              style={{ width: `${upload.hashing.total > 0 ? (upload.hashing.completed / upload.hashing.total) * 100 : 0}%` }}
            />
          </div>
        </>
      )}

      {showUpload && (
        <>
          <span>
            Uploading {upload.completed}/{upload.total}
          </span>
          <div className="w-32 h-1.5 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-300"
              style={{ width: `${upload.total > 0 ? (upload.completed / upload.total) * 100 : 0}%` }}
            />
          </div>
        </>
      )}

      {showUpload && showProcessing && <span>|</span>}

      {showProcessing && (
        <>
          <span>
            Processing {awaitingReviewCount + failedCount}/
            {processingCount + awaitingReviewCount + failedCount}
          </span>
          <div className="w-32 h-1.5 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-300"
              style={{
                width: `${
                  processingCount + awaitingReviewCount + failedCount > 0
                    ? ((awaitingReviewCount + failedCount) /
                       (processingCount + awaitingReviewCount + failedCount)) * 100
                    : 0
                }%`,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
